import { render, staticRenderFns } from "./CTailwindInput.vue?vue&type=template&id=21e82f80&scoped=true"
import script from "./CTailwindInput.vue?vue&type=script&lang=js"
export * from "./CTailwindInput.vue?vue&type=script&lang=js"
import style0 from "./CTailwindInput.vue?vue&type=style&index=0&id=21e82f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e82f80",
  null
  
)

export default component.exports